export default {
  configureCache() {
    if (this.ajax && this.ajaxUrl) {
      this.cacheKey = `select_cache_${this.ajaxUrl.toLowerCase()}`;
    } else if (this.thor && this.thorModel) {
      this.cacheKey = `select_cache_${this.name}_${this.thorModel.toLowerCase()}`;
    } else {
      this.cacheKey = `select_cache_${this.name}`;
    }
  },

  setCache(data) {
    if (RAILS_ENV === 'development' || !this.enableCache || !data || !data.length) return;
    try {
      sessionStorage.setItem(this.cacheKey, JSON.stringify(data));
    } catch (ex) {
      Rollbar.info('qselect: Cache lotado!', ex);
    }
  },

  getCache() {
    if (RAILS_ENV === 'development' || !this.enableCache) return;
    try {
      return JSON.parse(sessionStorage.getItem(this.cacheKey));
    } catch (ex) {
      this.clearCache();
      Rollbar.info(`qselect: Um cache inválido foi apagado. Key: ${this.cacheKey}`);
    }
  },

  clearCache() {
    sessionStorage.removeItem(this.cacheKey);
    this._execCallbacks('clearCache');
  }
};
